const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const { Bar, ReferenceLine, Tooltip } = require('recharts');
const TooltipValueTitle = require('components/charts/TooltipValueTitle/TooltipValueTitle');
const YearlyBarsLinesChart = require('components/charts/YearlyBarsLinesChart/YearlyBarsLinesChart');
const { formatAmount } = require('utilities/currencyHelper');
const { formatValue } = require('../utilities/valueFormater');

class AnnualReturnChart extends React.Component {
    render() {
        const { data } = this.props;
        return (
            <YearlyBarsLinesChart
                data={data}
                height={400}
                tickFormatter={v => `${formatAmount(v)} %`}
                width="100%"
            >
                <Bar dataKey="value" fill="#2ccefd" unit="%" stroke="#2ccefd" />
                <ReferenceLine y={0} stroke="#68748c" />
                <Tooltip
                    content={
                        <TooltipValueTitle
                            titleKey={properties =>
                                properties.payload[0].payload.date
                            }
                            titleFormat={title => moment(title).format('YYYY')}
                            valueFormat={v => `${formatValue(v)}`}
                        />
                    }
                />
            </YearlyBarsLinesChart>
        );
    }
}

AnnualReturnChart.propTypes = {
    data: PropTypes.array.isRequired,
    fund: PropTypes.object,
};

module.exports = AnnualReturnChart;
